import { createFileRoute, redirect } from '@tanstack/react-router'

/** Activity logs are admin-only; reseller panel route is disabled. */
export const Route = createFileRoute('/_authenticated/reseller/activity-logs')({
  beforeLoad: () => {
    throw redirect({ to: '/reseller', replace: true })
  },
})
